import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { bodyStyle } from './Navigation.css';

type Props = ComponentPropsWithRef<'div'>;

export const NavigationBody = ({ children, className, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(bodyStyle, className)}>
      {children}
    </div>
  );
};
